
require('./bootstrap');
require('./common');


import {addMutilatedSortingRow, addSortingRow} from "./sorting";
import {
    base_url,
    removeTableRow,
    CASH_CONDITIONS,
    confirmMessage,
    buildSelectOptions,
    getURLParameters
} from "./shared";
import {addCashForDestructionRow, redoCashForDestructionTable} from "./cash-destruction";
import {
    addDenomRow,
    addMutilatedDenomRow,
    prepareDenomSelectInput,
    redoDenomsTable,
    redoMutilatedDenomsTable
} from "./bank-requests";



$(function (){

    var denomData;
    var currentCurrencyId;
    removeTableRow();

    //Exporting table data
    $('.exportBtn').on('click', function (e){
        e.preventDefault();
        var format = $(this).data("format");
        var possibleForMats = ['PDF', 'CSV', 'EXCEL'];
        if (possibleForMats.includes(format)) {

           var urlParameters = getURLParameters();
            // Remove any existing forms
            $('form[name="parameterForm"]').remove();

            // Create a form element
            var form = $('<form>').attr({
                name: 'parameterForm'
            });

            // Set the form's action and method attributes
            form.attr({
                action: window.location.pathname, // Use the current path as the action
                method: 'GET'
            });

            // Append hidden input fields for each parameter to the form
            for (var key in urlParameters) {
                if (urlParameters.hasOwnProperty(key)) {
                    var value = urlParameters[key];
                    if (Array.isArray(value)) {
                        // If the parameter has multiple values, create an input field for each value
                        for (var i = 0; i < value.length; i++) {
                            var input = $('<input>').attr({
                                type: 'hidden',
                                name: key,
                                value: value[i]
                            });
                            form.append(input);
                        }
                    } else {
                        // If the parameter has a single value, create a single input field
                        var input = $('<input>').attr({
                            type: 'hidden',
                            name: key,
                            value: value
                        });
                        form.append(input);
                    }
                }
            }//end for

            // Append two additional hidden input fields
            form.append('<input type="hidden" name="download" value="true">');
            form.append(`<input type="hidden" name="format" value=${format}>`);

            // Append the form to the body and submit it
            $('body').append(form);
            form.submit();

        }//end if

    });

    $('.confirm-action').on('click', function (e) {
        return confirm("Are you sure you want to do this?");
    });

    $('.reject-permanently').on('click', function (e){
        e.preventDefault();
        var form = $(this).closest("form");
        var input = form.find("input[name='rejectPermanently']");
        if (input.length<1) {
            form.append("<input type='hidden' name='rejectPermanently' value='true' />");
        }
        return form.reportValidity();
    });

    //$('select').select2();
    //Data TakeOn
    $('#addNewCashTakeOnBtn').on('click', function (e) {
        var vaults = parsedVaults;
        var denoms = parsedDenoms;

        $('#dataTakeOnNewCashTable >tbody').append(
            `
            <tr>
                <td>YOUR BRANCH</td>
                <td>
                    <select name="denom" required class="form-select form-select-sm">
                        <option value="">Choose..</option>
                        ${buildSelectOptions(denoms)}
                    </select>
                </td>
                <td>
                    <input type="text" class="form-control form-control-sm" required name="startSerial">
                </td>
                <td>
                    <input type="text" class="form-control form-control-sm" required name="endSerial">
                </td>
                <td>
                    <select name="vault" required class="form-select form-select-sm">
                        <option value="">Choose..</option>
                        ${buildSelectOptions(vaults)}
                    </select>
                </td>
                <td>
                    <button class="btn btn-sm btn-danger remove-btn" type="button">Remove</button>
                </td>
            </tr>
            `
        );
        removeTableRow();

    });

    //Cash Destruction
    $('#addDestructionOfficialBtn').on('click', function (e){
        e.preventDefault();
        $('#officialsInvolvedTable >tbody').append(
            `
            <tr>
                <td>
                    <input type="text" name="fullName" required class="form-control form-control-sm">
                </td>
                <td>
                    <input type="text" name="nationalId" required class="form-control form-control-sm">
                </td>
                <td>
                    <input type="text" name="department" required class="form-control form-control-sm">
                </td>
                <td>
                    <button class="btn btn-sm btn-danger remove-btn" type="button">Remove</button>
                </td>

            </tr>
            `);
        removeTableRow();
    });

    $('.remove-official').on('click', function (e) {
        e.preventDefault();
        if (confirm(confirmMessage)) {
            var entryId = $(this).data('id');
            $(this).closest('form').append("<input type='hidden' name='removeOfficial' value='"+entryId+"' />");
            $(this).closest("tr").remove();
        }

    });

    $('.remove-denom-entry').on('click', function (e) {
        e.preventDefault();
        if(confirm(confirmMessage)) {
            var entryId = $(this).attr('data-id');
            $(this).closest('form').append("<input type='hidden' name='removeDenomEntry' value='"+entryId+"' />");
            $(this).closest("tr").remove();
        }
    })

    /*Sorting*/
    $('#addMutilatedDailyBtn').on('click', function (e) {
        e.preventDefault();
        var denoms = parsedDenoms;
        $('#mutilatedDailyReportTable > tbody').append(
            `
            <tr>
                <td>
                    <select class="form-select form-select-sm" required name="mutilatedDenoms">
                        <option value="">Choose...</option>
                        ${buildSelectOptions(denoms)}
                    </select>
                </td>
                <td>
                    <select class="form-select form-select-sm" required name="mutilatedValue">
                        <option value="">Choose...</option>
                        <option value="FULL">FULL</option>
                        <option value="HALF">HALF</option>
                        <option value="ZERO">ZERO</option>
                    </select>
                </td>
                <td>
                    <input type="number" min="0" step="1" name="mutilatedCount" required value="0" class="form-control form-control-sm">
                </td>
                <td>
                    <button class="btn btn-sm btn-danger remove-btn" type="button">Remove</button>
                </td>
            </tr>
            `
        );
        removeTableRow();
    });

    $('#addNormalDailyBtn').on('click', function (e) {
        e.preventDefault();
        var denoms = parsedDenoms;
        $('#normalDailyReportTable >tbody').append(
            `
            <tr>
                <td>
                    <select class="form-select form-select-sm" required name="normalDenoms">
                        <option value="">Choose...</option>
                        ${buildSelectOptions(denoms)}
                    </select>
                </td>
                <td>
                    <input type="number" min="0" name="fitCount" required value="0" class="form-control form-control-sm">
                </td>
                <td>
                    <input type="number" min="0" name="soiledCount" required value="0" class="form-control form-control-sm">
                </td>
                <td>
                    <input type="number" min="0" name="onlineDestroyed" required value="0" class="form-control form-control-sm">
                </td>
                <td>
                    <input type="number" min="0" name="mixedCount" required value="0" class="form-control form-control-sm">
                </td>
                <td>
                    <button class="btn btn-sm btn-danger remove-btn" type="button">Remove</button>
                </td>
            </tr>
            `
        );
        removeTableRow();
    });

    $('.remove-normal-daily-entry').on('click', function (e) {
        e.preventDefault();
        if (confirm(confirmMessage)) {
            var entryId = $(this).data('id');
            $(this).closest('form').append("<input type='hidden' name='removeNormalEntry' value='"+entryId+"' />");
            $(this).closest("tr").remove();
        }

    });

    $('.remove-mutilated-daily-entry').on('click', function (e) {
        e.preventDefault();
        if (confirm(confirmMessage)) {
            var entryId = $(this).data('id');
            $(this).closest('form').append("<input type='hidden' name='removeMutilatedEntry' value='"+entryId+"' />");
            $(this).closest("tr").remove();
        }

    });
    /*End Sorting*/

    var contextCurrency= $("input[type=hidden][name=contextCurrencyId]").val();
    if (contextCurrency) {
        $.ajax({
            type: 'GET',
            url: base_url+'/api/v1/currencies/'+contextCurrency,
            dataType: 'json',
            success: function (data) {
                denomData = data;
                prepareDenomSelectInput(denomData);
                addDenomRow(denomData);//1
                addMutilatedDenomRow(denomData);
                addSortingRow(denomData);
                addMutilatedSortingRow(denomData);
                addCashForDestructionRow(denomData);
            },
            error: function (err) {
                console.log(err);
                alert("Failed to fetch data.")
            }
        });
    }

    $('select').filter('[id="currency"]').on("change", function (e) {
        const val = this.value;
        if (val) {
            if (currentCurrencyId) {
                if (val!==currentCurrencyId) {
                    window.location.reload();
                }
            }
            currentCurrencyId = val;
            if (!$("input[type=hidden][name=contextCurrencyId]").length) {
                fetchDenominations(val);
            }
        } else {
            console.log("Empty value selected")
        }
    });


    function fetchDenominations(currencyId) {
        $.ajax({
            type: 'GET',
            url: base_url+'/api/v1/currencies/'+currencyId,
            dataType: 'json',
            success: function (data) {
                denomData = data;
                prepareDenomSelectInput(denomData);
                redoDenomsTable(denomData);
                redoMutilatedDenomsTable(denomData);
                addDenomRow(denomData); //2
                addMutilatedDenomRow(denomData);
                //redoSortingCashTable(denomData);
                //redoMutilatedSortingCashTable(denomData);
                //addSortingRow(denomData);
                //addMutilatedSortingRow(denomData);
                redoCashForDestructionTable(denomData);
                addCashForDestructionRow(denomData)
            },
            error: function (err) {
                console.log(err);
                alert("Failed to fetch data.")
            }
        });
    }

});

